import { postWithAuthLocal } from './api/client';
import apiVariables from './api/apiVariables';
import type { TalentSearchResponse } from '../types/talentSearch';

interface TalentSearchEnvelope {
  success: boolean;
  message?: string;
  data?: TalentSearchResponse;
}

export const searchTalent = async (query: string, maxResults?: number) => {
  const response = await postWithAuthLocal<TalentSearchEnvelope>(apiVariables.ASK_ISENTRYX_AI_SEARCH, {
    query: query.trim(),
    maxResults,
  });

  if (!response.success || !response.data) {
    throw new Error(response.message || 'Unable to search for talent.');
  }

  return response.data;
};
